// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3eB1e","productName":"Table_productName__2UPVc"};